<template>
    <div>
        <game-detail :details='details'></game-detail>
    </div>
</template>

<script>
import gameDetail from '../../components/gamedetail/gamedetail'

import logo_img from '../../images/xianlaigame/xl_phz.png'
import ercodeimg from '../../images/gamecenter_ercode/ercode_phz.png'
import list_img1 from '../../images/download/down-phz1.jpg'
import list_img2 from '../../images/download/down-phz2.jpg'
import list_img3 from '../../images/download/down-phz3.jpg'
import cut_img1 from '../../images/download/phzjt1.jpeg'
import cut_img2 from '../../images/download/phzjt2.jpeg'
import cut_img3 from '../../images/download/phzjt3.jpeg'
export default {
    data(){
        return{
            details:{
                logo_img:logo_img,
                name:'闲来跑胡子',
                size:'93',
                load_count:'172',
                desp:'闲来游戏推出重度力作“闲来跑胡子”，画面精美，玩法正宗，更安全，更省流量。它具有简单易上手的特色规则、刺激明快的游戏节奏、独特精致的游戏画面以及轻松搞笑的音乐特效，是一款极具人气的高质量跑胡子游戏。并且玩法多样，可创建房间与现实中好友畅快对决！',
                ios_url:'http://app1.xlsymj.com/?downloadfrom=paohuzi',
                android_url:'http://app1.xlsymj.com/?downloadfrom=paohuzi',
                ercodeimg:ercodeimg,
                list_img1:list_img1,
                list_img2:list_img2,
                list_img3:list_img3,
                cut_img1:cut_img1,
                cut_img2:cut_img2,
                cut_img3:cut_img3
            }
        }
    },
    components:{
        gameDetail
    }
}
</script>

<style scoped>

</style>
